import React from 'react'
import '../styles/SectionHeading.scss'

const SectionHeading = () => {
  return (
    <div className="section-title-wrapper">
<h1 className="title">Development Practical Test</h1>
<p>Thank you for choosing and giving me this wonderful opportunity which allows me to showcase my ability in coding.
This pratical development test was done with NodeJs and MangoDB as the backend technologies and ReactJs, javascript.
There is the implementation of backend CRUD operations,frontend, backend input valiadation and AJAX server request and mobile responsiveness.

I also implement the same project with PHP and MYSQL. Kindly view the link for the project.
</p>
<span className="line"></span>
</div>
  )
}

export default SectionHeading